import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {VetReservationService} from "../providers/vet-reservation.service";
import {VetReservationsDgSearchResults} from "../models/datagrid-search-results/vet-reservations.dg-search-results.model";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";

@Injectable()
export class VetReservationsResolve implements Resolve<VetReservationsDgSearchResults> {
  constructor(private vetReservationService: VetReservationService,private appStateService: AppStateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<VetReservationsDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.vetReservationService.getResults( environment.DEFAULT_RESULTS_LIMIT,0,'DESC','created').pipe(tap(res => {
      if (res && res.results.length > 0) {
        this.appStateService.updateOnDataGridRefreshNeededSubject(res);
      }
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
